import { createStyles, Theme } from "@material-ui/core";

export const styles = (theme: Theme) =>
  createStyles({
    sideNavFooter: {
      display: "flex",
      flexDirection: "column",
      alignItems: "center",
      "& > *": {
        height: "30px",
        marginBottom: "10px"
      },
      "& > *:first-child": {
        height: "1px",

      },
      "& > .MuiDivider-root": {
        width: "100%"
      }
    },

  });
